<template>
  <a-modal title="添加教学资源包" width="1300px" :visible="visible" :cancelText="modalText.cancel" :okText="modalText.ok" :confirm-loading="submitLoading" @ok="handleOk" @cancel="handleCancel">
    <div style="max-height: 600px; min-height: 400px; overflow: auto">
      <a-steps :current="currentStep" labelPlacement="vertical">
        <a-step title="选择资源包"> </a-step>
        <a-step title="使用设置" />
        <a-step title="确认信息" />
      </a-steps>
      <div v-show="currentStep === 0" style="margin: 12px 0">
        <SelectTeachResourse v-if="visible" ref="SelectTeachResourseRef"></SelectTeachResourse>
      </div>
      <div v-show="currentStep === 1" style="margin: 12px 0">
        <a-form :form="sourceForm" class="source-form" :labelCol="{ span: 4 }" :wrapperCol="{ span: 12 }">
          <a-row style="margin-bottom: 20px" v-for="(item, index) in copySlectRow" :key="index">
            <a-col class="title" :span="18" :offset="6">
              <a-form-item :wrapperCol="{ span: 24 }">
                <span class="title-wrapper" v-show="!item.edit">
                  {{ item.name }} <span @click="editItem(item, true, false, index), (item.c_name = item.name)"><a-icon type="form" class="icon" /></span>
                </span>
                <div class="title-input" v-show="item.edit">
                  <a-input style="width: 200px" v-model.trim="item.name" :maxLength="20" />
                  <div>
                    <a-icon type="check-circle" class="icon" style="color: #15d6ba" @click="editItem(item, false, true)" />
                    <a-icon type="close-circle" style="color: red" class="icon" @click="editItem(item, false), (item.name = item.c_name)" />
                  </div>
                </div>
              </a-form-item>
            </a-col>
            <a-col :span="18" :offset="6">
              <a-form-item
                label="可使用份数"
                :validate-status="isEmpty(item.maxCount) && !item.isLimitCount ? 'error' : 'success'"
                :help="isEmpty(item.maxCount) && !item.isLimitCount ? '请输入可使用份数' : ''"
              >
                <div class="item">
                  <a-input
                    placeholder="请输入可使用份数"
                    @input="changeInput(e, index, 'maxCount')"
                    @blur="blurInput(e, index, 'maxCount')"
                    style="width: 60%"
                    v-model="item.maxCount"
                    :disabled="item.isLimitCount"
                  />
                  <a-checkbox @change="changeCheck($event, index, 'isLimitCount')" :checked="item.isLimitCount"> 不限制 </a-checkbox>
                </div>
              </a-form-item>
            </a-col>

            <a-col :span="18" :offset="6">
              <a-form-item
                label="截止使用日期"
                :validate-status="isEmpty(item.uneffectiveDate) && !item.isLimitUsageDate && !item._init ? 'error' : 'success'"
                :help="isEmpty(item.uneffectiveDate) && !item.isLimitUsageDate && !item._init ? '请输入截止使用日期' : ''"
              >
                <div class="item">
                  <a-date-picker
                    style="width: 60%"
                    @change="changeTime($event, index)"
                    :value="item.uneffectiveDate ? moment(item.uneffectiveDate) : undefined"
                    :disabledDate="disabledDate"
                    :disabled="item.isLimitUsageDate"
                  />
                  <a-checkbox @change="changeCheck($event, index, 'isLimitUsageDate')" :checked="item.isLimitUsageDate"> 永久使用 </a-checkbox>
                </div>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div v-show="currentStep === 2" style="margin: 20px 0 12px 0">
        <div class="card-row" v-for="(item, index) in copySlectRow" :key="index">
          <div class="title">
            {{ item.name }}
          </div>
          <div class="card-row-body">
            <div>
              <span>可使用份数：</span>
              {{ item.isLimitCount ? '不限制' : item.maxCount }}
            </div>
            <div>
              <span>可使用至：</span>
              {{ item.isLimitUsageDate ? '永久使用' : moment(item.uneffectiveDate).format('YYYY/MM/DD') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import moment from 'moment'
import SelectTeachResourse from '@/pages/projectImpl/orgManage/components/selectTeachResourse.vue'

const text = {
  0: {
    ok: '下一步',
    cancel: '取消',
  },
  1: {
    ok: '下一步',
    cancel: '上一步',
  },
  2: {
    ok: '保存',
    cancel: '上一步',
  },
}
export default {
  name: 'AddSourceModal',
  components: { SelectTeachResourse },
  computed: {
    modalText() {
      return text[this.currentStep]
    },
    submitLoading() {
      if (this.currentStep == 0) {
        return this.confirmLoading || this.$refs['SelectTeachResourseRef']?.confirmLoading
      }
      return this.confirmLoading
    },
  },
  data() {
    return {
      moment,
      sourceForm: this.$form.createForm(this, { name: 'coordinated' }),
      gradeTableRelevant: tableRelevant.call(this),
      gradeColumns: [
        {
          title: '资源包名称',
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '资源包个数',
          dataIndex: 'count',
        },
        {
          title: '文件大小',
          scopedSlots: { customRender: 'size' },
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
        },
        {
          title: '状态',
          scopedSlots: { customRender: 'enabled' },
        },
      ],
      visible: false,
      confirmLoading: false,
      currentStep: 0,
      searchForm: {},
      copySlectRow: [],
      allSelect: [],
    }
  },
  created() {
    this._oInfo = {
      oId: this.$route.query.id || sessionStorage.getItem('ORGANIZATION_ID'),
      uneffectiveDate: this.$route.query.uneffectiveDate || sessionStorage.getItem('ORGANIZATION_DATA'),
    }
  },
  methods: {
    disabledDate(current) {
      // const uneffectiveDate = this._oInfo.uneffectiveDate
      // || (current && current > moment(uneffectiveDate).endOf('day'))
      return current && current < moment().endOf('day')
    },
    isEmpty(value) {
      if (!value && value !== 0) {
        return true
      }
      return false
    },
    changeInput(_, index, key) {
      let val = this.copySlectRow[index][key]
      const Reg1 = `[^\\d\.]`
      const Reg2 = /^0(\d+)/
      const Reg3 = /^\./
      const Reg4 = /\.{1,}/g
      const Reg5 = /^(\d+)\.(\d\d).*$/
      val = String(val).replace(new RegExp(Reg1, 'g'), '')
      val = val
        .replace(Reg2, '$1')
        .replace(/(?=\-)/g, '')
        .replace(Reg3, '')
        .replace(Reg4, '')
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
        .replace(Reg5, '$1')
      this.copySlectRow[index][key] = val
      return val
    },
    blurInput(_, index, key) {
      let val = this.copySlectRow[index][key]
      if (val == 0) {
        val = 1
      }
      this.copySlectRow[index][key] = val
    },
    changeCheck(e, index, key) {
      this.copySlectRow[index][key] = e.target.checked
      this.$set(this.copySlectRow[index], key, e.target.checked)
      this.copySlectRow = [...this.copySlectRow]
    },
    changeTime(e, index) {
      if (!e) {
        this.copySlectRow[index].uneffectiveDate = undefined
      } else {
        this.copySlectRow[index].uneffectiveDate = moment(e).format('YYYY-MM-DD')
      }
      this.copySlectRow[index]._init = false
      this.copySlectRow = [...this.copySlectRow]
    },
    editItem(record, bol, flag, index) {
      if (flag) {
        if (!record.name && record.name !== 0) {
          return this.$message.error('请输入资源包名称')
        }
        for (let i = 0; i < this.copySlectRow.length; i++) {
          const item = this.copySlectRow[i]
          if (record.id === item.id) {
            continue
          }
          if (record.name == item.name) {
            this.$set(record, 'edit', true)
            return this.$message.error('名称与其他资源包重复，请更换')
          }
        }
      }
      this.$set(record, 'edit', bol)
      // this.copySlectRow[index] = {...item}
    },
    getPageList(pageIndex) {
      return new Promise((resolve, reject) => {
        const params = {
          pageIndex: pageIndex || this.gradeTableRelevant.tablePagination.current,
          pageSize: this.gradeTableRelevant.tablePagination.pageSize,
          ...this.searchForm,
        }
        let str = '?'
        if (this.allSelect.length) {
          this.allSelect.forEach((v) => {
            str += `ExcludedResourcePackageIds=${v}&`
          })
          str = str.slice(0, -1)
        }

        this.gradeTableRelevant.tableLoading = true
        this.$http.TResource.getPageList(params, str).then((res) => {
          this.gradeTableRelevant.tableLoading = false
            this.gradeTableRelevant.tableDataSource = res.data.items
            this.gradeTableRelevant.tablePagination.total = res.data.totalCount
            this.gradeTableRelevant.tablePagination.current = res.data.pageIndex
            resolve()
        }).catch(e => {
          this.gradeTableRelevant.tableLoading = false
          reject()
        })
      })
    },
    showModal(params = {}, oId) {
      return new Promise((resolve, reject) => {
        this._resolve = resolve
        this.currentStep = 0
        this._reject = reject
        this._params = params
        this._oId = oId
        this.visible = true
        this.gradeTableRelevant.tableLoading = true
        this.$nextTick(() => {
          this.$refs['SelectTeachResourseRef'] && this.$refs['SelectTeachResourseRef'].getListAll()
        })
      })
    },
    submitActive1(cb) {
      const params = this.copySlectRow.map((v) => {
        const data = {
          id: this._params.id,
          name: v.name,
          organizationId: this._oInfo.oId,
          resourcePackageId: v.id,
          maxCount: v.maxCount,
          isLimitCount: !v.isLimitCount,
          isLimitUsageDate: !v.isLimitUsageDate,
          organizationName: sessionStorage.getItem('ORGANIZATION_NAME'),
          source: 0,
        }
        if (data.isLimitUsageDate) {
          data.uneffectiveDate = v.uneffectiveDate ? v.uneffectiveDate : this._oInfo.uneffectiveDate
        }
        return data
      })

      this.$http.CourseService.resourseBatchEdit(params).then((res) => {
        this.$message.success('保存成功')
        cb && cb()
      })
    },
    handleOk() {
      if (this.currentStep == 0) {
        if (this.submitLoading) return
        this.confirmLoading = true
        const selectList = this.$refs['SelectTeachResourseRef'].courseSelectedRowKeys.map((v) => JSON.parse(v))
        if (!selectList.length) {
          return this.$message.warning('请选择资源包')
        }
        this.currentStep = 1
        this.sourceForm.resetFields()
        this.copySlectRow = JSON.parse(JSON.stringify(selectList)).map((v) => ({
          ...v,
          maxCount: 1,
          isLimitCount: false,
          isLimitUsageDate: false,
          _init: true,
          uneffectiveDate: moment().add(1, 'year').format('YYYY-MM-DD HH:mm:ss'),
        }))
        this.confirmLoading = false
      } else if (this.currentStep == 1) {
        const flag = this.copySlectRow.some((v) => {
          if ((this.isEmpty(v.maxCount) && !v.isLimitCounte) || (!v.uneffectiveDate && !v.isLimitUsageDate)) {
            this.$message.error('请完善资源包信息')
            return true
          }
        })

        if (!flag) {
          this.copySlectRow = this.copySlectRow.map((v) => ({ ...v, edit: false }))
          this.currentStep = 2
        }
      } else if (this.currentStep == 2) {
        this.confirmLoading = true
        this.submitActive1(() => {
          this.visible = false
          this.confirmLoading = false
          this._resolve && this._resolve()
          this._params = {}
          this.copySlectRow = []
          this.$refs['SelectTeachResourseRef'].courseSelectedRowKeys = []
          this.$refs['SelectTeachResourseRef'].seriesSelectedRowKeys = []
        })
      }
    },
    handleCancel(e = {}) {
      const { target } = e
      if (target?.classList.contains('ant-btn')) {
        if (this.currentStep == 2) {
          this.currentStep = 1
        } else if (this.currentStep == 1) {
          this.currentStep = 0
        } else if (this.currentStep == 0) {
          this.visible = false
          this._params = {}
          this.copySlectRow = []
          this._reject && this._reject()
          this.$refs['SelectTeachResourseRef'].courseSelectedRowKeys = []
          this.$refs['SelectTeachResourseRef'].seriesSelectedRowKeys = []
        }
      } else {
        this.visible = false
        this._reject && this._reject()
        this._params = {}
        this.copySlectRow = []
        this.$refs['SelectTeachResourseRef'].courseSelectedRowKeys = []
        this.$refs['SelectTeachResourseRef'].seriesSelectedRowKeys = []
      }
    },
  },
}
</script>
<style lang="less" scoped>
.source-form {
  width: 100%;
  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .title {
    display: flex;
    align-items: center;
    font-weight: 700;
    font-size: 15px;
    .title-wrapper {
      max-width: 300px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .icon {
    margin: 0 12px;
    cursor: pointer;
    font-size: 20px;
  }
  .title-input {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
}
.source-form ::v-deep .ant-form-item {
  margin-bottom: 10px;
}
.card-row {
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  width: 400px;
  margin: auto;
  margin-bottom: 16px;
  .title {
    font-weight: 700;
    font-size: 14px;
  }
  .card-row-body {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 14px;
  }
}
.table-name {
  display: flex;
  align-items: center;
  img {
    margin-right: 4px;
  }
}
</style>
